import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from '@/hooks/useGlobalState'

/**
 * Hook to check if the sponsor account is disabled due to billing issues.
 * Used to display warnings in the UI when payment is required.
 */
export function useBillingDisabledStatus() {
  const { api } = useGlobalState()

  const sponsorInfoQuery = useQuery({
    queryKey: ['sponsor', 'info'],
    queryFn: () => api.getSponsorInfo(),
    staleTime: 5 * 60 * 1000,
  })

  const isDisabledDueToBilling = sponsorInfoQuery.data?.disabledDueToBilling ?? false
  const ignoreBilling = sponsorInfoQuery.data?.ignoreBilling ?? false
  const isBillingRestricted = !ignoreBilling && isDisabledDueToBilling

  return {
    isDisabledDueToBilling,
    ignoreBilling,
    isBillingRestricted,
    isLoading: sponsorInfoQuery.isLoading,
  }
}
